import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '@services/auth.service';
import { jwtDecode } from 'jwt-decode';
import { UserToken } from '@interfaces/token';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = localStorage.getItem('gesthosp_user_pep');

    if (token) {
      const decodedToken: UserToken = jwtDecode(token);

      if (decodedToken.exp * 1000 < Date.now()) {
        this.authService.logout();
        location.reload();
      }
    }

    return next.handle(request);
  }
}
